import React from 'react';
import PropTypes from 'prop-types';
import './HeroCard.scss';

class HeroCard extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    dangerouslySetBodyText: PropTypes.any,
    dangerouslySetBodyTextIsHTML: PropTypes.bool,
    headingHiddenOnMobile: PropTypes.bool,
    headingText: PropTypes.string,
    bodyClass: PropTypes.string,
  };

  static defaultProps = {
    headingHiddenOnMobile: false,
  }

  renderHeading() {
    let headingClass = '';

    if (!this.props.headingText) {
      headingClass += ' hidden';
    }

    if (this.props.headingHiddenOnMobile) {
      headingClass += ' hidden-xs';
    }

    return <h1 className={headingClass}>{this.props.headingText}</h1>;
  }

  renderBodyText() {
    let bodyText = null;
    let className = 'aa-flow-body-text';
    if (this.props.bodyClass) {
      className += ` ${this.props.bodyClass}`;
    }
    if (this.props.headingHiddenOnMobile) {
      className += ' remove-margin-top';
    }

    if (this.props.dangerouslySetBodyText) {
      if (this.props.dangerouslySetBodyTextIsHTML) {
        /* Do not pass in user input because of XSS risks with dangerouslySetInnerHTML */
        bodyText = (
          <div
            className={className}
            dangerouslySetInnerHTML={this.props.dangerouslySetBodyText}
          />
        );
      } else {
        /* Do not pass in user input because of XSS risks with dangerouslySetInnerHTML */
        bodyText = (
          <div
            className={className}
            dangerouslySetInnerHTML={{ __html: this.props.dangerouslySetBodyText }}
          />
        );
      }
    }
    return bodyText;
  }

  render() {
    return (
      <div className="aa-hero-card">
        <div className="hero-card-content container">
          {this.renderHeading()}
          {this.renderBodyText()}
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default HeroCard;
